import { connectHits } from 'instantsearch.js/es/connectors'
import { get } from '@bigyouth/base'
import moment from 'moment'

const renderHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams } = renderOptions

  if (hits.length !== 0) {
    widgetParams.container.innerHTML = '<ul class="row"></ul>'

    hits.forEach((hit) => {
      // create li element, add classes
      const li = document.createElement('li')
      li.classList.add('col-12')
      li.classList.add('md-col-6')
      li.classList.add('lg-col-4')
      li.classList.add('mb-6')
      li.classList.add('flex')

      const format = hit.locale === 'en' ? 'MM/DD/YY' : 'DD/MM/YY'
      const publishDate = hit.publishDate ? moment(new Date(hit.publishDate.date)).locale(config.locale).format(format) : ''

      const isNewsWorld = hit.actuType === 'Les actus du monde de l\'Eau' || hit.actuType === 'News from the water world' || hit.actuType === 'Noticias del mundo del agua'

      li.innerHTML = `
      <div class="news-card">
        <div class="news-card__top ${isNewsWorld ? 'news-card__top--green' : ''}">
            <div class="flex flex-wrap z-1 relative">
              ${hit.thematics
                ? hit.thematics.map(thematic => {
                  return `<a href="${thematic.url}" class="thematic thematic--white mr-1 mb-2">${thematic.name}</a>`
                }).join('')
                : ''
              }
            </div>
            ${hit.hasLogo
              ? `<img class="mx-auto news-card__logo" src="https://res.cloudinary.com/oieau/image/upload/f_auto,q_auto,w_300/${hit.picture.singleMedia.publicId}" alt="${hit.picture.singleMedia.alt}"/>`
              : `<img class="h-full w-full object-cover news-card__top-img" src="https://res.cloudinary.com/oieau/image/upload/f_auto,q_auto,c_fill,w_500,h_400/${hit.picture.singleMedia.publicId}" alt="${hit.picture.singleMedia.alt}"/>`
            }
            <svg class="icon icon--white news-card__top--wave" aria-hidden="true" preserveAspectRatio="xMinYMax meet" viewBox="0 0 2000 200" x="0" y="0">
                <use href="#wave-horizontal" xlink:href="#wave-horizontal"></use>
            </svg>
        </div>
        <div class="news-card__bottom">
            <div class="mb-7">
                <div class="flex items-center">
                    <svg width="12" height="12" class="mr-1 icon icon--medium-grey">
                        <use href="#icon-duration" xlink:href="#icon-duration"></use>
                    </svg>
                    <span class="text-12 text-medium-grey">${config.trads['list.actuality.publish']} ${publishDate}</span>
                </div>
                <span class="title-4 title-4--medium ${isNewsWorld ? 'title-4--green' : 'title-4--dark-blue'} mt-2 block">${hit.title}</span>
                ${hit.description
                  ? `<div class="paragraph mt-4">
                      ${hit.description}
                    </div>`
                  : ''
                }
            </div>
            
            <div class="news-card__actions">
              <a onclick="_paq.push(['trackEvent', 'Click', 'Actualités', '${config.trads['list.actuality.read']}'])" href="${hit.path}" class="cta ${isNewsWorld ? 'cta--light-green' : ''} ">${config.trads['list.actuality.read']}</a>
            </div>
        </div>
      </div>
      `
      get('ul', widgetParams.container).appendChild(li)
    })
  } else {
    widgetParams.container.innerHTML = config.trads['list.actuality.empty']
  }
}

const customHitsActuality = connectHits(renderHits)

export default customHitsActuality
